export default __webpack_public_path__ + "static/media/WD-1502 15 Inch touch screen POS system.e6979f9a.jpg";